@if (shouldDisplayApplyButton()) {
    @if (!isEpcotEnabled) {
        @if (!selectedTokenModel()) {
            <button
                ds-button
                kind="primary"
                variant="filled"
                size="small"
                class="linear-rewards-selector__content"
                [wrapText]="true"
                (click)="onClick($event)">
                <vn-icon slot="start" name="theme-plus"></vn-icon>
                {{ selectorMessages.apply }}
            </button>
        } @else {
            <button
                ds-button
                kind="tertiary"
                variant="filled"
                size="small"
                class="linear-rewards-selector__content linear-rewards-selector__content--selected"
                [wrapText]="true"
                (click)="onClick($event)">
                @if (selectedTokenModel()!.icon) {
                    <vn-icon slot="start" [name]="selectedTokenModel()!.icon"></vn-icon>
                }
                {{ getTokenTitle(selectedTokenModel()!.title) }}
                <span class="success-icon-color-state" slot="end">
                    <vn-icon class="linear-rewards-selector__icon--success" name="theme-success-i"></vn-icon>
                </span>
            </button>
        }
    } @else {
        @if (selectedTokenModel()) {
            <div class="linear-rewards-selector__content--epcot" (click)="onClick($event)">
                <div class="linear-rewards-selector__icon--epcot" [ngClass]="tokenIconClass"></div>
                <span class="linear-rewards-selector__title--epcot">
                    @if (freeBetAmount) {
                        <span class="linear-rewards-selector__token-value--epcot">{{
                            freeBetAmount | bsCurrency: true : 2 : true : undefined : undefined : false
                        }}</span>
                    }
                    {{ selectedTokenModel()!.title }}
                </span>
                <div class="linear-rewards-selector__divider--epcot"></div>
                <button ds-button kind="tertiary" variant="flat-reduced" size="small">{{ selectorMessages.edit }}</button>
            </div>
        } @else {
            <button ds-button kind="secondary" variant="outline" size="small" (click)="onClick($event)">
                {{ selectorMessages.apply }}
            </button>
        }
    }
}

@if (infoEnabled) {
    <div
        class="reward-tokens-selector__info-button"
        [bsHighlightToggle]="{ highlightedClass: 'theme-info-i', unhighlightedClass: 'theme-info' }"
        (click)="displayInfo($event)"></div>
}

@if (hasAcquisitionOnboarding() || displayAddWelcomeOfferTooltip()) {
    <bs-acquisition-reward-onboarding-container
        [selectedToken]="selectedToken()"
        [displayAddWelcomeOfferTooltip]="displayAddWelcomeOfferTooltip()"
        (hideAddWelcomeOfferTooltip)="hideAddWelcomeOfferTooltip()" />
}
